import React, { Component } from "react";
import Request from "superagent";

import { API_BASE } from "./api";
import Picks, { fromServerJSON } from "./Picks";
import { subscribe } from "./Scores";

function withLivePicks(Wrapped) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        picks: new Picks(),
      };

      this.onMessage = this.onMessage.bind(this);
      this.onStatus = this.onStatus.bind(this);
    }

    componentDidMount() {
      this.refreshBoard();
      this.sub = subscribe(`lobby/${this.props.lobbyCode}`, this.onMessage, this.onStatus);
    }

    componentWillUnmount() {
      this.sub && this.sub.unsubscribe();
      this.sub = null;
    }

    onMessage(message) {
      this.setState({
        picks: fromServerJSON(message.data),
      });
    }
    onStatus(status) {}

    refreshBoard() {
      Request.get(`${API_BASE}/lobby/${this.props.lobbyCode}`).end((err, res) => {
        // TODO error handling
        this.setState({
          picks: fromServerJSON(res.body.data),
        });
      });
    }

    render() {
      return <Wrapped picks={this.state.picks} {...this.props} />;
    }
  };
}
export default withLivePicks;



// WEBPACK FOOTER //
// ./src/withLivePicks.js